module.exports = __webpack_public_path__ + "img/collection-diamondJewelry100Carat.27f8767.jpg";